import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';

@model.cacheDuration()
@model.urnResource('user_status')
@doc.path('/user_statuses/{?id}')
export default class UserStatusModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'reference': Account_UserStatusReference;
		'userStatusHistories': id;
		'users': id;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Account_UserStatusReference;

	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'success';
			case 'DISABLED':
				return 'error';
			case 'PENDING_VERIFICATION':
				return 'processing';
			default:
				return 'default';
		}
	}
}